<template>
    <div class="bg-black relative">
        <div class="bg-center h-[400px] md:h-[650px] bg-cover bg-no-repeat"
             :class="light ? 'opacity-100' : 'opacity-50'"
             :style="{
                backgroundImage: 'url(' + backgroundImage + ')'
            }">
        </div>
        <div class="w-full h-full flex items-center justify-center absolute top-0 left-0">
            <h1 class="text-white uppercase text-3xl md:text-6xl">{{ title }}</h1>
        </div>
    </div>
</template>

<script>
export default {
    name: "OrganismPageHeader",
    props: {
        backgroundImage: null,
        title: {
            type: String,
        },
        light: {
            type: Boolean,
        }
    },
}
</script>
